import { httpHelper } from '@/utils'
import Vue from 'vue'

const state = {
    warnings: [],
    allWarnings: [], // includes resolved warnings
    isWarningsFetching: false,
}

const getters = {
    assetWarningsMap: state => {
        return state.allWarnings
            .filter(w => w.asset)
            .reduce((map, warning) => {
                if (!map[warning.asset]) {
                    map[warning.asset] = []
                }
                map[warning.asset].push(warning)
                return map
            }, {})
    },
    driverWarningsMap: state => {
        return state.allWarnings
            .filter(w => w.driver)
            .reduce((map, warning) => {
                if (!map[warning.driver]) {
                    map[warning.driver] = []
                }
                map[warning.driver].push(warning)
                return map
            }, {})
    },
}

const actions = {
    async fetchWarnings({ commit }) {
        commit('setIsWarningsFetching', true)

        try {
            const allWarnings = httpHelper
                .getRecursively('/alertrule-notifications/', {
                    params: {
                        limit: process.env.VUE_APP_LIMIT_RECORDS_PER_REQUEST,
                        resolved: false,
                    },
                })
                .filter(({ asset, driver }) => asset || driver)
            commit('allWarnings', allWarnings)
        } catch (error) {
            console.error('Error fetching warnings:', error)
        } finally {
            commit('setIsWarningsFetching', false)
        }
    },
    async dismissWarning({ commit }, id) {
        commit('updateWarning', { id, resolved: true }) // update for instant UI feedback
        return httpHelper
            .patch(`/alertrule-notifications/${id}/`, {
                resolved: true,
            })
            .then(({ data }) => commit('updateWarning', data))
            .catch(error => {
                console.error('Error dismissing warning:', error)
                commit('updateWarning', { id, resolved: false })
            })
    },
}

const mutations = {
    setWarnings(state, warnings) {
        state.warnings = warnings
    },
    setAllWarnings(state, allWarnings) {
        state.allWarnings = allWarnings
    },
    setIsWarningsFetching(state, isFetching) {
        state.isWarningsFetching = isFetching
    },
    updateWarning(state, { id, ...data }) {
        const index = state.allWarnings.findIndex(warning => warning.id === id)
        if (index === -1) {
            return
        }
        const warning = { ...state.allWarnings[index], ...data }
        Vue.set(state.allWarnings, index, warning)
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
